import React, { useState, useEffect, useRef } from "react";
import * as NetworkHelper from "../../utilities/Networkhelper";
import CommonHelper from "../../utilities/CommonHelper";
import { LkInputText } from "../../components/LkInputText";
import { LkInputNumber } from "../../components/LkInputNumber";
import { useFormik } from "formik";
import { BlockUI } from "primereact/blockui";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import StringHelper from "../../utilities/StringHelper";
import Consts from "../../utilities/Consts";
export const CustomerBalanceEdit = (props) => {
  const { cus_id  } = props;
  const cLabels = Consts.localizedStrings;
  const baseUrl = Consts.network.customers;
  const [blocked, setBlocked] = useState(false);
  const [errors, setErrors] = useState({});
  const isFirstRender = useRef(true);
  const formik = useFormik({
    initialValues: {
      id: undefined,
      cus_code: undefined,
      cus_firm: undefined,
      balance: 0, 
    },
    validateOnChange: false,
    validateOnBlur: false,
    validate: (data) => {
      let errors = {};
 
      // if (StringHelper.isEmptyInJson(data, "balance")  ) {
      //   errors.balance = cLabels.requiredField;
      // }

      setErrors(errors);
      if (Object.keys(errors).length !== 0) {
        CommonHelper.showWarnMessage(cLabels.lutfen_girdiginiz_bigileri_kontrol_ediniz);
      }

      return errors;
    },
    onSubmit: (data) => { 
      _update(data);

    },
  });
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      _getItem();
    }
  });
  const _getItem = async () => {
    try {
      if (StringHelper.isNotEmpty(cus_id)) {
        let resp = await NetworkHelper.call_web_service(baseUrl.get, {
          id: cus_id,
        });
        formik.setValues( resp.item);
      }
    } catch (error) {
      console.log(error);
      CommonHelper.handleCatch(error);
    } finally {
    }
  }; //=>end
      
  const _update = async (_formData = formik.values) => {
    try {
      setBlocked(true);

      let resp = await NetworkHelper.call_web_service(baseUrl.update, {
        ..._formData,
      });
      let msg = CommonHelper.getCreateMessage(resp);
      CommonHelper.showSuccessMessage(msg);
      props.onCloseSidebar(resp.save_response);
    } catch (error) {
      console.log(error);
      CommonHelper.handleCatch(error);
    } finally {
      setBlocked(false);
    }
  }; //=>end _create
  const template = (options) => {
    const className = `${options.className} p-jc-start`;
    const titleClassName = `${options.titleClassName} p-pl-1`;

    return (
      <div className={className}>
        <span className={titleClassName}>{cLabels.update_balance}</span>
        <Button icon="pi pi-times" className="p-button-rounded p-button-danger" onClick={() => props.onCloseSidebar()} />
      </div>
    );
  };
  return (
    <Panel headerTemplate={template} toggleable>
      <BlockUI blocked={blocked} fullScreen />
      <form id="balance-form" onSubmit={formik.handleSubmit}>
        <div className="col-12">
          <div className="p-fluid p-formgrid grid">
            <fieldset className="col-12">
              <legend></legend>
              <div className="grid">
                <div className="p-field col-12">
                  <label >{cLabels.id}</label>
                  <LkInputText type="text" id="id"  formik={formik} disabled />
                </div>
                <div className="p-field col-12">
                  <label >{cLabels.cus_code}</label>
                  <LkInputText type="text" id="cus_code"  formik={formik} disabled />
                </div>
                <div className="p-field col-12">
                  <label >{cLabels.cus_firm}</label>
                  <LkInputText type="text" id="cus_firm"  formik={formik} disabled />
                </div>
                <div className="p-field col-12">
                  <label >{cLabels.cus_name}</label>
                  <LkInputText type="text" id="cus_name"  formik={formik} disabled />
                </div>
                <div className="p-field col-12">
                  <label >{cLabels.cus_surname}</label>
                  <LkInputText type="text" id="cus_surname"  formik={formik} disabled />
                </div>
                 
                <div className="p-field col-6">
                  <label>{cLabels.balance}</label>
                  <LkInputNumber id="balance" mode="decimal" minFractionDigits={2} maxFractionDigits={2} showButtons   formik={formik} />
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </form>
      <Toolbar
        left={
          <React.Fragment>
            <Button label={cLabels.cancel} onClick={() => props.onCloseSidebar()} type="submit" form="xxx-form" icon="pi pi-times" className="p-button-sm p-button-warning" />
          </React.Fragment>
        }
        right={
          <React.Fragment>
            <Button label={cLabels.save} type="submit" form="balance-form" icon="pi pi-check" className="p-button-success p-mr-2" />
          </React.Fragment>
        }
      />
    </Panel>
  );
};
